import type { AccountMailboxType } from 'owa-graph-schema';

import OUTLOOK_SVG from '../svg/Outlook.svg';
import GOOGLE_SVG from '../svg/Google.svg';
import ICLOUD_SVG from '../svg/iCloud.svg';
import OFFICE365_SVG from '../svg/Office365.svg';
import YAHOO_SVG from '../svg/Yahoo.svg';
import OTHER_SVG from '../svg/OtherProvider.svg';

export function getIconFromAccountType(accountType: AccountMailboxType): string {
    // We don't have designs for the logos of all the account types
    // TODO Define and implement logos for all the account types
    // https://outlookweb.visualstudio.com/Outlook%20Web/_workitems/edit/108746
    switch (accountType) {
        case 'OUTLOOKDOTCOM':
            return OUTLOOK_SVG;
        case 'GOOGLE':
            return GOOGLE_SVG;
        case 'OFFICE365':
            return OFFICE365_SVG;
        case 'YAHOO':
            return YAHOO_SVG;
        case 'ICLOUD':
            return ICLOUD_SVG;
        case 'OTHER':
        default:
            // End up mapping the undefined case to OTHER
            return OTHER_SVG;
    }
}
